import XmlClient from './clients/XmlClient';

export {
	XmlClient as XmlClient
};
